import React from "react";
import "./NewsBlock.css";

const NewsBlock = ({ data }) => {
  // return (
  //   <div className="news-updates-rows">
  //     {data?.map((item, index) => (
  //       <h3>
  //         <a
  //           className="link"
  //           href={item.link}
  //           key={index}
  //           dangerouslySetInnerHTML={{ __html: item.title.rendered }}
  //           target="_blank"
  //           rel="noreferrer"
  //         ></a>
  //       </h3>
  //     ))}
  //   </div>
  // );

  const displayDate = (date) => {
    let year = date.split("-")[0];
    let month = date.split("-")[1];

    if (month === "01") {
      return "JANUARY, " + year;
    }
    if (month === "02") {
      return "FEBRUARY, " + year;
    }
    if (month === "03") {
      return "MARCH, " + year;
    }
    if (month === "04") {
      return "APRIL, " + year;
    }
    if (month === "05") {
      return "MAY, " + year;
    }
    if (month === "06") {
      return "JUNE, " + year;
    }
    if (month === "07") {
      return "JULY, " + year;
    }
    if (month === "08") {
      return "AUGUST, " + year;
    }
    if (month === "09") {
      return "SEPTEMBER, " + year;
    }
    if (month === "10") {
      return "OCTOBER, " + year;
    }
    if (month === "11") {
      return "NOVEMBER, " + year;
    }
    if (month === "12") {
      return "DECEMBER, " + year;
    }
  };

  return (
    <div className="news-items-block">
      {console.log("WORKING AS IT SHOULD BE!")}
      {data.length > 0 ? (
        data?.map((item, index) => (
          <div className="single-news-item" key={index}>
            <a
              className="single-news-link"
              onClick={() => (window.parent.location = item.link)}
              href="#"
            >
              <div className="image-container">
                <img
                  className="news-image"
                  src={
                    item.yoast_head_json.og_image[0]
                      ? item.yoast_head_json.og_image[0].url
                      : "null"
                  }
                  alt="damenmc_news"
                ></img>
              </div>

              <p className="news-date">{displayDate(item.date)}</p>
              <p
                className="news-description"
                dangerouslySetInnerHTML={{ __html: item.title.rendered }}
              ></p>
            </a>
          </div>
        ))
      ) : (
        <div className="no-news-found">
          <h3>No news found.</h3> <br />
          <p>
            <i
              onClick={() => {
                window.parent.location.reload();
              }}
              class="fa-solid fa-arrows-rotate"
            ></i>
            Please refresh or clear your search.
          </p>
        </div>
      )}
    </div>
  );
};

export default NewsBlock;
